<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
      <el-form-item label="学生名" prop="studentName">
        <el-input v-model="dataForm.studentName" disabled placeholder="学生名"></el-input>
      </el-form-item>
      <el-form-item label="班级名" prop="className">
        <el-input v-model="dataForm.className" disabled placeholder="班级名"></el-input>
      </el-form-item>
      <el-form-item label="社团名称" prop="clubName">
        <el-input v-model="dataForm.clubName" disabled placeholder="社团名称"></el-input>
      </el-form-item>
      <el-form-item label="点名状态" prop="studentStatus">
        <template>
          <el-radio-group v-model="dataForm.studentStatus">
            <el-radio :label="rollStatus.normal">正常</el-radio>
            <el-radio :label="rollStatus.leave">请假</el-radio>
          </el-radio-group>
        </template>
      </el-form-item>
      <el-form-item label="点名日期" prop="rollDate">
        <el-date-picker
                v-model="dataForm.rollDate"
                type="date"
                placeholder="点名日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="点名教师" prop="rollTeacher">
        <el-input v-model="dataForm.rollTeacher" disabled placeholder="点名教师"></el-input>
      </el-form-item>
      <el-form-item label="班主任名" prop="headTeacherName">
        <el-input v-model="dataForm.headTeacherName" disabled placeholder="班主任名"></el-input>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
import { rollStatus } from '../../../constant'
export default {
  data () {
    return {
      visible: false,
      rollStatus,
      dataForm: {
        id: '',
        studentId: '',
        studentName: '',
        classId: '',
        className: '',
        studentNum: '',
        studentSex: '',
        setNum: '',
        clubId: '',
        clubName: '',
        studentStatus: '',
        schoolId: '',
        creator: '',
        updater: '',
        createDate: '',
        updateDate: '',
        rollDate: '',
        rollTeacher: '',
        headTeacherName: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.dataForm.resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get('/club/clubRoll/' + this.dataForm.id).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs.dataForm.validate((valid) => {
        if (!valid) {
          return false
        }
        const date = new Date(this.dataForm.rollDate)
        this.dataForm.rollDate = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
        this.$http[!this.dataForm.id ? 'post' : 'put']('/club/clubRoll/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { leading: true, trailing: false })
  }
}
</script>
